import { LandingNav } from "@/components/landing/LandingNav";
import { Hero } from "@/components/landing/Hero";
import { TrustedBy } from "@/components/landing/TrustedBy";
import { Features } from "@/components/landing/Features";
import { CapitalSection } from "@/components/landing/CapitalSection";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { PricingPreview } from "@/components/landing/PricingPreview";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { LandingFooter } from "@/components/landing/LandingFooter";

const Landing = () => {
  return (
    <div className="min-h-screen bg-[hsl(222_47%_5%)] text-white overflow-x-hidden font-sans">
      <LandingNav />
      <main>
        <Hero />
        <TrustedBy />
        <Features />
        <CapitalSection />
        <HowItWorks />
        <PricingPreview />
        <FinalCTA />
      </main>
      <LandingFooter />
    </div>
  );
};

export default Landing;
